<section class="content companies-record-detail-page">
  <div class="content-block companies-record-detail-page__content">
    <div class="block-header companies-record-detail-page__header">
      <app-breadcrumb [title]="'MENUITEMS.ORGANIZATION.TEXT' | translate"
                      [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <mat-card class="companies-record-detail-page__card"
              [class.companies-record-detail-page__card--loading]="isLoading">
      @if (isLoading) {
      <div class="companies-record-detail-page__loading">
        <app-loading-state [message]="'masterTable.loading' | translate" />
      </div>
      } @else {
      <div class="companies-record-detail-page__card-header">
        <div>
          <h3>{{ pageTitle }}</h3>
          <p>{{ 'companiesRecordsCatalog.detailDescription' | translate }}</p>
        </div>

        <div class="companies-record-detail-page__actions">
          @if (isViewMode && canEdit) {
          <button mat-stroked-button
                  class="btn-tone-primary"
                  type="button"
                  (click)="goToEdit()">
            <mat-icon>edit</mat-icon>
            {{ 'common.update' | translate }}
          </button>
          }

          @if (!isViewMode) {
          <button mat-flat-button
                  class="btn-tone-primary"
                  type="button"
                  [disabled]="isLoading"
                  (click)="save()">
            <mat-icon>save</mat-icon>
            {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
          </button>
          }

          <button mat-stroked-button
                  class="btn-tone-neutral"
                  type="button"
                  (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            {{ 'common.back' | translate }}
          </button>
        </div>
      </div>

      <div class="companies-record-detail-page__body">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex"
                       class="companies-record-detail-page__tabs">
          <mat-tab [label]="'companiesRecordsCatalog.tabs.general' | translate">
            <div class="companies-record-detail-page__form">
              <mat-form-field appearance="outline"
                              subscriptSizing="dynamic">
                <mat-label>
                  {{ 'companiesRecordsCatalog.fields.name' | translate }}
                  @if (isCreateMode) {
                  <span class="companies-record-detail-page__required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  }
                </mat-label>
                <input matInput
                       [(ngModel)]="entityForm.name"
                       [readonly]="isViewMode">
              </mat-form-field>

              <mat-form-field appearance="outline"
                              subscriptSizing="dynamic">
                <mat-label>
                  {{ 'companiesRecordsCatalog.fields.code' | translate }}
                  @if (isCreateMode) {
                  <span class="companies-record-detail-page__required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  }
                </mat-label>
                <input matInput
                       data-no-spaces="true"
                       [(ngModel)]="entityForm.code"
                       [readonly]="isViewMode">
              </mat-form-field>

              @if (!isCreateMode) {
              <mat-form-field appearance="outline"
                              class="col-xl-12"
                              subscriptSizing="dynamic">
                <mat-label>{{ 'companiesRecordsCatalog.fields.isActive' | translate }}</mat-label>
                @if (isViewMode) {
                <input matInput
                       [value]="entityForm.isActive ? ('common.status.active' | translate) : ('common.status.inactive' | translate)"
                       readonly>
                } @else {
                <mat-select [(ngModel)]="entityForm.isActive">
                  <mat-option [value]="true">{{ 'common.status.active' | translate }}</mat-option>
                  <mat-option [value]="false">{{ 'common.status.inactive' | translate }}</mat-option>
                </mat-select>
                }
              </mat-form-field>
              }

              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                              class="companies-record-detail-page__full-width">
                <mat-label>
                  {{ 'companiesRecordsCatalog.fields.description' | translate }}
                  @if (isCreateMode) {
                  <span class="companies-record-detail-page__required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  }
                </mat-label>
                <textarea matInput
                          rows="5"
                          data-allow-unicode="true"
                          [(ngModel)]="entityForm.description"
                          [readonly]="isViewMode"></textarea>
              </mat-form-field>
            </div>
          </mat-tab>

          @if (!isCreateMode) {
          <mat-tab [label]="'companiesRecordsCatalog.tabs.workAssignment' | translate">
            <div class="companies-record-detail-page__assignment">
              <div class="companies-record-detail-page__assignment-header">
                <div>
                  <h4>{{ 'companiesRecordsCatalog.workAssignment.title' | translate }}</h4>
                  <p>{{ 'companiesRecordsCatalog.workAssignment.description' | translate }}</p>
                </div>

                @if (!isViewMode) {
                <div class="companies-record-detail-page__assignment-toggle">
                  <span>{{ 'companiesRecordsCatalog.workAssignment.enabled' | translate }}</span>
                  <mat-slide-toggle [(ngModel)]="workAssignmentForm.enabled"
                                    (ngModelChange)="onWorkAssignmentToggle()">
                  </mat-slide-toggle>
                </div>
                }
              </div>

              @if (isViewMode) {
              <div class="companies-record-detail-page__assignment-grid">
                <div class="companies-record-detail-page__soft-card">
                  <span>{{ 'companiesRecordsCatalog.workAssignment.workCycleId' | translate }}</span>
                  <strong>{{ selectedWorkCycleName }}</strong>
                </div>
                <div class="companies-record-detail-page__soft-card">
                  <span>{{ 'companiesRecordsCatalog.workAssignment.restConfigurationId' | translate }}</span>
                  <strong>{{ selectedRestConfigurationName }}</strong>
                </div>
                <div class="companies-record-detail-page__soft-card">
                  <span>{{ 'companiesRecordsCatalog.workAssignment.cycleStartDate' | translate }}</span>
                  <strong>{{ displayedWorkAssignment?.cycleStartDate || '-' }}</strong>
                </div>
                <div class="companies-record-detail-page__soft-card">
                  <span>{{ 'companiesRecordsCatalog.workAssignment.effectiveFrom' | translate }}</span>
                  <strong>{{ displayedWorkAssignment?.effectiveFrom || '-' }}</strong>
                </div>
                <div class="companies-record-detail-page__soft-card">
                  <span>{{ 'companiesRecordsCatalog.workAssignment.effectiveTo' | translate }}</span>
                  <strong>{{ displayedWorkAssignment?.effectiveTo || ('companiesRecordsCatalog.workAssignment.openEnded' | translate) }}</strong>
                </div>
              </div>

              <div class="employees-detail-page__section-card companies-record-detail-page__full-width companies-record-detail-page__rules-card">
                <div class="employees-detail-page__section-header companies-record-detail-page__rules-header">
                  <span>
                    <h5>{{ 'workAssignmentRules.title' | translate }}</h5>
                    <p>{{ 'workAssignmentRules.description' | translate }}</p>
                  </span>
                </div>

                <div class="companies-record-detail-page__assignment-grid">
                  <div class="companies-record-detail-page__soft-card">
                    <span>{{ 'workAssignmentRules.entryToleranceMinutes' | translate }}</span>
                    <strong>{{ displayedWorkAssignment?.toleranceRules?.entryToleranceMinutes ?? '-' }}</strong>
                  </div>
                  <div class="companies-record-detail-page__soft-card">
                    <span>{{ 'workAssignmentRules.earlyExitToleranceMinutes' | translate }}</span>
                    <strong>{{ displayedWorkAssignment?.toleranceRules?.earlyExitToleranceMinutes ?? '-' }}</strong>
                  </div>
                  <div class="companies-record-detail-page__soft-card">
                    <span>{{ 'workAssignmentRules.roundingMarginMinutes' | translate }}</span>
                    <strong>{{ displayedWorkAssignment?.toleranceRules?.roundingMarginMinutes ?? '-' }}</strong>
                  </div>
                  <div class="companies-record-detail-page__soft-card">
                    <span>{{ 'workAssignmentRules.ignoreOvertime' | translate }}</span>
                    <strong>{{ displayedWorkAssignment?.overtimePolicy?.ignoreOvertime ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                  </div>
                </div>
              </div>
              } @else {
              <div class="companies-record-detail-page__assignment-grid">
                <div class="employees-detail-page__section-card companies-record-detail-page__full-width companies-record-detail-page__assignment-config-card">
                  <div class="companies-record-detail-page__assignment-config-grid">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'companiesRecordsCatalog.workAssignment.workCycleId' | translate }}</mat-label>
                      <mat-select [(ngModel)]="workAssignmentForm.workCycleId"
                                  [disabled]="!workAssignmentForm.enabled"
                                  (ngModelChange)="onWorkCycleChange()">
                        <mat-option value="">{{ 'common.select' | translate }}</mat-option>
                        @for (cycle of workCycles; track cycle.workCycleId) {
                        <mat-option [value]="cycle.workCycleId">{{ cycle.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'companiesRecordsCatalog.workAssignment.restConfigurationId' | translate }}</mat-label>
                      <mat-select [(ngModel)]="workAssignmentForm.restConfigurationId"
                                  [disabled]="!workAssignmentForm.enabled">
                        <mat-option value="">{{ 'common.select' | translate }}</mat-option>
                        @for (restConfiguration of restConfigurations; track restConfiguration.restConfigurationId) {
                        <mat-option [value]="restConfiguration.restConfigurationId">{{ restConfiguration.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <!-- Cycle offset is intentionally hidden until offset-based assignments are enabled again. -->
                    <div class="companies-record-detail-page__assignment-dates-row">
                      <app-date-time-picker-field [label]="'companiesRecordsCatalog.workAssignment.cycleStartDate' | translate"
                                                  [value]="workAssignmentForm.cycleStartDate"
                                                  mode="date"
                                                  [required]="true"
                                                  [disabled]="!workAssignmentForm.enabled"
                                                  (valueChange)="onWorkAssignmentDateChange('cycleStartDate', $event)">
                      </app-date-time-picker-field>

                      <app-date-time-picker-field [label]="'companiesRecordsCatalog.workAssignment.effectiveFrom' | translate"
                                                  [value]="workAssignmentForm.effectiveFrom"
                                                  mode="date"
                                                  [disabled]="!workAssignmentForm.enabled"
                                                  (valueChange)="onWorkAssignmentDateChange('effectiveFrom', $event)">
                      </app-date-time-picker-field>

                      <app-date-time-picker-field [label]="'companiesRecordsCatalog.workAssignment.effectiveTo' | translate"
                                                  [placeholder]="'companiesRecordsCatalog.workAssignment.openEnded' | translate"
                                                  [value]="workAssignmentForm.effectiveTo"
                                                  mode="date"
                                                  [disabled]="!workAssignmentForm.enabled"
                                                  (valueChange)="onWorkAssignmentDateChange('effectiveTo', $event)">
                      </app-date-time-picker-field>
                    </div>
                  </div>
                </div>

                <div class="employees-detail-page__section-card companies-record-detail-page__full-width companies-record-detail-page__rules-card">
                  <div class="employees-detail-page__section-header companies-record-detail-page__rules-header">
                    <span>
                      <h5>{{ 'workAssignmentRules.title' | translate }}</h5>
                      <p>{{ 'workAssignmentRules.description' | translate }}</p>
                    </span>
                  </div>

                  <div class="companies-record-detail-page__rules-grid">
                    <div class="companies-record-detail-page__rule-field">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline">
                        <mat-label>{{ 'workAssignmentRules.entryToleranceMinutes' | translate }}</mat-label>
                        <input matInput
                               type="number"
                               min="0"
                               step="1"
                               [(ngModel)]="workAssignmentForm.toleranceRules.entryToleranceMinutes"
                               [disabled]="!workAssignmentForm.enabled">
                      </mat-form-field>
                    </div>

                    <div class="companies-record-detail-page__rule-field">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline">
                        <mat-label>{{ 'workAssignmentRules.earlyExitToleranceMinutes' | translate }}</mat-label>
                        <input matInput
                               type="number"
                               min="0"
                               step="1"
                               [(ngModel)]="workAssignmentForm.toleranceRules.earlyExitToleranceMinutes"
                               [disabled]="!workAssignmentForm.enabled">
                      </mat-form-field>
                    </div>

                    <div class="companies-record-detail-page__rule-field">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline">
                        <mat-label>{{ 'workAssignmentRules.roundingMarginMinutes' | translate }}</mat-label>
                        <input matInput
                               type="number"
                               min="0"
                               step="1"
                               [(ngModel)]="workAssignmentForm.toleranceRules.roundingMarginMinutes"
                               [disabled]="!workAssignmentForm.enabled">
                      </mat-form-field>
                    </div>

                    <div class="companies-record-detail-page__rules-toggle companies-record-detail-page__rules-toggle--wide">
                      <mat-icon class="companies-record-detail-page__rules-toggle-icon">timer_off</mat-icon>
                      <mat-slide-toggle [(ngModel)]="workAssignmentForm.overtimePolicy.ignoreOvertime"
                                        [disabled]="!workAssignmentForm.enabled">
                        {{ 'workAssignmentRules.ignoreOvertime' | translate }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>

                <div class="employees-detail-page__section-card companies-record-detail-page__full-width companies-record-detail-page__cycle-card">
                  <div class="employees-detail-page__section-header">
                    <h4>{{ 'companiesRecordsCatalog.workAssignment.cyclePreview.title' | translate }}</h4>
                    <p>{{ 'companiesRecordsCatalog.workAssignment.cyclePreview.description' | translate }}</p>
                  </div>

                  @if (assignmentSelectedScheduleMonth; as scheduleMonth) {
                  <div class="employees-detail-page__cycle-calendar">
                    <div class="employees-detail-page__cycle-calendar-toolbar">
                      <button mat-icon-button
                              type="button"
                              [disabled]="!hasPreviousAssignmentScheduleMonth"
                              (click)="showPreviousAssignmentScheduleMonth()">
                        <mat-icon>chevron_left</mat-icon>
                      </button>

                      <strong class="employees-detail-page__cycle-calendar-title">{{ scheduleMonth.label }}</strong>

                      <button mat-icon-button
                              type="button"
                              [disabled]="!hasNextAssignmentScheduleMonth"
                              (click)="showNextAssignmentScheduleMonth()">
                        <mat-icon>chevron_right</mat-icon>
                      </button>
                    </div>

                    <div class="employees-detail-page__cycle-planner-head">
                      @for (weekday of assignmentWeekdayLabels; track weekday) {
                      <div class="employees-detail-page__cycle-planner-head-cell">{{ weekday }}</div>
                      }
                    </div>

                    <div class="employees-detail-page__cycle-planner-weeks">
                      @for (week of [0, 1, 2, 3, 4, 5]; track week) {
                      <div class="employees-detail-page__cycle-planner-week">
                        @for (day of scheduleMonth.days.slice(week * 7, (week + 1) * 7); track $index) {
                        <article class="employees-detail-page__cycle-planner-cell"
                                 [class.employees-detail-page__cycle-planner-cell--outside]="!day.isCurrentMonth"
                                 [class.employees-detail-page__cycle-planner-cell--rest]="day.previewDay?.isRest"
                                 [class.employees-detail-page__cycle-planner-cell--range]="day.isInRange"
                                 [class.employees-detail-page__cycle-planner-cell--start]="day.isStart"
                                 [class.employees-detail-page__cycle-planner-cell--end]="day.isEnd">
                          <div class="employees-detail-page__cycle-planner-cell-top">
                            <strong class="employees-detail-page__cycle-planner-date">{{ day.dayNumber }}</strong>
                            @if (day.previewDay) {
                            <span class="employees-detail-page__cycle-planner-order">
                              {{ 'companiesRecordsCatalog.workAssignment.cyclePreview.day' | translate:{ day: day.previewDay.dayOrder } }}
                            </span>
                            }
                          </div>

                          @if (day.previewDay) {
                          <div class="employees-detail-page__cycle-planner-body">
                            <span class="employees-detail-page__cycle-planner-weekday">{{ day.weekdayLabel }}</span>
                            <strong class="employees-detail-page__cycle-planner-range">{{ day.previewDay.scheduleRange }}</strong>
                            <span class="employees-detail-page__cycle-planner-name">{{ day.previewDay.scheduleName }}</span>
                            <small class="employees-detail-page__cycle-planner-hours">{{ day.previewDay.expectedHours }}</small>
                          </div>
                          } @else {
                          <div class="employees-detail-page__cycle-planner-body employees-detail-page__cycle-planner-body--empty">
                            <span class="employees-detail-page__cycle-planner-muted">
                              {{ 'companiesRecordsCatalog.workAssignment.cyclePreview.outsideRange' | translate }}
                            </span>
                          </div>
                          }
                        </article>
                        }
                      </div>
                      }
                    </div>
                  </div>
                  } @else {
                  <div class="employees-detail-page__cycle-preview-empty">
                    <mat-icon>event_busy</mat-icon>
                    <span>{{ 'companiesRecordsCatalog.workAssignment.cyclePreview.empty' | translate }}</span>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </mat-tab>
          }

          @if (!isCreateMode) {
          <mat-tab [label]="'companiesRecordsCatalog.tabs.devices' | translate">
            <div class="companies-record-detail-page__assignment">
              <div class="companies-record-detail-page__assignment-header">
                <div>
                  <h4>{{ 'devicesCatalog.breadcrumb' | translate }}</h4>
                  <p>{{ 'companiesRecordsCatalog.devices.description' | translate }}</p>
                </div>
              </div>

              @if (isViewMode) {
              @if (selectedDeviceIds.length) {
              <div class="companies-record-detail-page__assignment-grid">
                @for (device of devices; track device.deviceId) {
                @if (selectedDeviceIds.includes(device.deviceId)) {
                <div class="companies-record-detail-page__soft-card">
                  <span>{{ device.serial || '-' }}</span>
                  <strong>{{ device.name || '-' }}</strong>
                </div>
                }
                }
              </div>
              } @else {
              <div class="companies-record-detail-page__soft-card">
                <span>{{ 'devicesCatalog.breadcrumb' | translate }}</span>
                <strong>{{ 'companiesRecordsCatalog.devices.empty' | translate }}</strong>
              </div>
              }
              } @else {
              <div class="companies-record-detail-page__assignment-grid">
                <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                class="companies-record-detail-page__full-width">
                  <mat-label>{{ 'devicesCatalog.breadcrumb' | translate }}</mat-label>
                  <mat-select [(ngModel)]="selectedDeviceIds"
                              multiple>
                    @for (device of devices; track device.deviceId) {
                    <mat-option [value]="device.deviceId">
                      {{ device.name || device.serial }} @if (device.serial) {<span>({{ device.serial }})</span>}
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }
            </div>
          </mat-tab>
          }

          @if (!isCreateMode && canReadAttendanceConfig) {
          <mat-tab [label]="'attendanceConfigsCatalog.tabLabel' | translate">
            <div class="companies-record-detail-page__assignment">
              <div class="companies-record-detail-page__assignment-header">
                <div>
                  <!-- <h4>{{ 'attendanceConfigsCatalog.title' | translate }}</h4> -->
                  <p>{{ 'attendanceConfigsCatalog.description' | translate }}</p>
                </div>

                @if (!isViewMode && canManageAttendanceConfig) {
                <div class="companies-record-detail-page__assignment-toggle">
                  <span>{{ 'attendanceConfigsCatalog.enabled' | translate }}</span>
                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.enabled"
                                    (ngModelChange)="onAttendanceConfigToggle()">
                  </mat-slide-toggle>
                </div>
                }
              </div>

              <div class="attendance-config-workspace__layout attendance-config-workspace__layout--full">
                <div class="attendance-config-workspace__main">

                  @if (isViewMode) {
                  @if (displayedAttendanceConfig; as attendanceConfig) {
                  <div class="companies-record-detail-page__section-card">
                    <div class="companies-record-detail-page__assignment-grid">
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.allowedSources' | translate }}</span>
                        <strong>{{ attendanceConfigSourcesLabel }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</span>
                        <strong>{{ attendanceConfigZonesLabel }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}</span>
                        <strong>{{ attendanceConfig.attendanceCapture.requireGeo ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}</span>
                        <strong>{{ attendanceConfig.attendanceCapture.requireFaceEvidence ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</span>
                        <strong>{{ attendanceTrackingIntervalLabel }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireOnlineConnection' | translate }}</span>
                        <strong>{{ attendanceConfig.tracking.requireOnlineConnection ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.allowOutOfZonePunch' | translate }}</span>
                        <strong>{{ attendanceConfig.zones.allowOutOfZonePunch ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireRegisteredDevice' | translate }}</span>
                        <strong>{{ attendanceConfig.deviceRules?.requireRegisteredDevice ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.requireDeviceBinding' | translate }}</span>
                        <strong>{{ attendanceConfig.deviceRules?.requireDeviceBinding ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'attendanceConfigsCatalog.fields.isActive' | translate }}</span>
                        <strong>{{ attendanceConfig.isActive !== false ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</strong>
                      </div>
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.enableAutoClose' | translate }}</span>
                        <strong>{{ attendanceConfig.turnPolicy?.enableAutoClose ? ('common.yes' | translate) : ('common.no' | translate) }}</strong>
                      </div>
                      @if (attendanceConfig.turnPolicy?.enableAutoClose) {
                      <div class="companies-record-detail-page__soft-card">
                        <span>{{ 'workAssignmentRules.autoCloseGraceMinutes' | translate }}</span>
                        <strong>{{ attendanceConfig.turnPolicy?.autoCloseGraceMinutes ?? '-' }}</strong>
                      </div>
                      }
                    </div>
                  </div>
                  } @else {
                  <div class="companies-record-detail-page__section-card">
                    <div class="companies-record-detail-page__soft-card">
                      <span>{{ 'attendanceConfigsCatalog.emptyTitle' | translate }}</span>
                      <strong>{{ 'attendanceConfigsCatalog.emptyDescription' | translate }}</strong>
                    </div>
                  </div>
                  }
                  } @else {
                  <div class="companies-record-detail-page__section-card">
                    <div class="row g-3 attendance-config-layout">
                      <div class="col-12 pt-3">
                        <mat-form-field appearance="outline"
                                        subscriptSizing="dynamic"
                                        style="width: 100%;">
                          <mat-label>{{ 'attendanceConfigsCatalog.fields.allowedSources' | translate }}</mat-label>
                          <mat-select [(ngModel)]="attendanceConfigForm.allowedSources"
                                      [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                      (ngModelChange)="onAttendanceAllowedSourcesChange()"
                                      multiple>
                            @for (source of attendanceSourceOptions; track source) {
                            <mat-option [value]="source">{{ ('attendanceConfigsCatalog.sources.' + source) | translate }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="col-12">
                        <div class="companies-record-detail-page__soft-card h-100">
                          <span>{{ 'workAssignmentRules.enableAutoClose' | translate }}</span>
                          <div class="row g-3 mt-1 align-items-center">
                            <div class="col-12 col-lg-auto">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.turnPolicy.enableAutoClose"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'workAssignmentRules.enableAutoClose' | translate }}
                              </mat-slide-toggle>
                            </div>
                            @if (attendanceConfigForm.turnPolicy.enableAutoClose) {
                              <div class="col-12 col-lg">
                              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'workAssignmentRules.autoCloseGraceMinutes' | translate }}</mat-label>
                                <input matInput
                                       type="number"
                                       min="0"
                                       step="1"
                                       [(ngModel)]="attendanceConfigForm.turnPolicy.autoCloseGraceMinutes"
                                       [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                              </mat-form-field>
                            </div>
                            }
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="companies-record-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.captureDefault' | translate }}</span>
                          <div class="row g-3 mt-1">
                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</mat-label>
                                <mat-select [(ngModel)]="attendanceConfigForm.timezone"
                                            [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  @for (timezone of attendanceTimezoneOptions; track timezone) {
                                  <mat-option [value]="timezone">{{ timezone }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>

                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</mat-label>
                                <input matInput
                                       type="number"
                                       min="1"
                                       step="1"
                                       [(ngModel)]="attendanceConfigForm.duplicateWindowSeconds"
                                       [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row g-2 mt-2 row-cols-1 row-cols-md-2 row-cols-xl-5">
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.requireGeo"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}
                              </mat-slide-toggle>
                            </div>
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.requireFaceEvidence"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}
                              </mat-slide-toggle>
                            </div>
                          </div>
                        </div>
                      </div>

                      @if (attendanceConfigForm.allowedSources.length > 0) {
                      <div class="col-12">
                        <div class="companies-record-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.sourceOverrides' | translate }}</span>
                          <div class="row g-3 mt-1">
                            @for (source of attendanceSourceRuleOptions; track source) {
                            @if (isAttendanceSourceEnabled(source)) {
                            <div class="col-12 col-md-6 col-xl-4">
                              <div class="companies-record-detail-page__soft-card h-100">
                                <span>{{ 'attendanceConfigsCatalog.sections.captureForSource' | translate:{ source: (getAttendanceSourceLabelKey(source) | translate) } }}</span>
                                <div class="d-flex align-items-center gap-2 mt-2">
                                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].enabled"
                                                    [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                                    (ngModelChange)="onAttendanceSourceRuleToggle(source)">
                                    {{ 'attendanceConfigsCatalog.fields.customizeSource' | translate }}
                                  </mat-slide-toggle>
                                </div>

                                @if (attendanceConfigForm.sourceRules[source].enabled) {
                                <div class="row g-3 mt-1">
                                  @if (attendanceSourceUsesTimezone(source)) {
                                  <div class="col-12">
                                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                                      <mat-label>{{ 'attendanceConfigsCatalog.fields.timezone' | translate }}</mat-label>
                                      <mat-select [(ngModel)]="attendanceConfigForm.sourceRules[source].timezone"
                                                  [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                        @for (timezone of attendanceTimezoneOptions; track timezone) {
                                        <mat-option [value]="timezone">{{ timezone }}</mat-option>
                                        }
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                  }

                                  @if (attendanceSourceUsesDuplicateWindow(source)) {
                                  <div class="col-12">
                                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                                      <mat-label>{{ 'attendanceConfigsCatalog.fields.duplicateWindowSeconds' | translate }}</mat-label>
                                      <input matInput
                                             type="number"
                                             inputmode="numeric"
                                             [(ngModel)]="attendanceConfigForm.sourceRules[source].duplicateWindowSeconds"
                                             [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    </mat-form-field>
                                  </div>
                                  }
                                </div>

                                @if (source !== 'device') {
                                <div class="d-flex flex-column gap-2 mt-2">
                                  @if (attendanceSourceUsesGeo(source)) {
                                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireGeo"
                                                    [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    {{ 'attendanceConfigsCatalog.fields.requireGeo' | translate }}
                                  </mat-slide-toggle>
                                  }
                                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireFaceEvidence"
                                                    [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    {{ 'attendanceConfigsCatalog.fields.requireFaceEvidence' | translate }}
                                  </mat-slide-toggle>
                                  @if (attendanceSourceUsesDeviceRules(source)) {
                                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireRegisteredDevice"
                                                    [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    {{ 'attendanceConfigsCatalog.fields.requireRegisteredDevice' | translate }}
                                  </mat-slide-toggle>
                                  <mat-slide-toggle [(ngModel)]="attendanceConfigForm.sourceRules[source].requireDeviceBinding"
                                                    [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                    {{ 'attendanceConfigsCatalog.fields.requireDeviceBinding' | translate }}
                                  </mat-slide-toggle>
                                  }
                                </div>
                                }
                                } @else {
                                <strong class="mt-2 d-block">{{ 'attendanceConfigsCatalog.fields.inheritGeneralConfig' | translate }}</strong>
                                }
                              </div>
                            </div>
                            }
                            }
                          </div>
                        </div>
                      </div>
                      }

                      <div class="col-12">
                        <div class="companies-record-detail-page__soft-card h-100">
                          <span>{{ 'attendanceConfigsCatalog.sections.tracking' | translate }}</span>
                          <div class="row g-3 mt-1">
                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic" appearance="outline">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.trackingIntervalSeconds' | translate }}</mat-label>
                                <mat-select [(ngModel)]="attendanceConfigForm.trackingIntervalSeconds"
                                            [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                  @for (interval of attendanceTrackingIntervalOptions; track interval) {
                                  <mat-option [value]="interval">{{ interval < 60 ? interval + ' s' : (interval / 60) + ' min' }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-6">
                              <mat-form-field subscriptSizing="dynamic" appearance="outline"
                                              style="width: 100%;">
                                <mat-label>{{ 'attendanceConfigsCatalog.fields.allowedZones' | translate }}</mat-label>
                                <mat-select [(ngModel)]="attendanceConfigForm.allowedZoneIds"
                                            [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig"
                                            multiple>
                                  @for (zone of zoneOptions; track zone.zoneId) {
                                  <mat-option [value]="zone.zoneId">{{ zone.name }}</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="row g-2 mt-2 row-cols-1 row-cols-md-2 row-cols-xl-3">
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.trackable"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.trackable' | translate }}
                              </mat-slide-toggle>
                            </div>
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.requireOnlineConnection"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.requireOnlineConnection' | translate }}
                              </mat-slide-toggle>
                            </div>
                            <div class="col">
                              <mat-slide-toggle [(ngModel)]="attendanceConfigForm.allowOutOfZonePunch"
                                                [disabled]="!attendanceConfigForm.enabled || !canManageAttendanceConfig">
                                {{ 'attendanceConfigsCatalog.fields.allowOutOfZonePunch' | translate }}
                              </mat-slide-toggle>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  }
                </div>

              </div>
            </div>
          </mat-tab>
          }
        </mat-tab-group>
      </div>
      }
    </mat-card>
  </div>
</section>
